export function useOwnedChannelsQuery() {
  return useQuery(queries().teamMode.all);
}
